import React from "react";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

import { GTM_ASK_STARTERS } from "../constants/gtmAskStarters";

export interface GtmAskStartersProps {
  onSelect: (prompt: string) => void;
  disabled?: boolean;
}

/**
 * Empty-state starter chips for GTM Ask (story 12.4).
 * Chips call sendTurn with fixed prompts — not the managing-prompt catalog.
 */
const GtmAskStarters: React.FC<GtmAskStartersProps> = ({ onSelect, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2" data-testid="gtm-ask-starters">
      <p className="text-[11px] font-medium uppercase tracking-wide text-gray-500">
        {t("Starting points")}
      </p>
      <ul className="flex flex-col gap-2">
        {GTM_ASK_STARTERS.map((starter) => (
          <li key={starter.id}>
            <button
              type="button"
              disabled={disabled}
              data-testid={`gtm-ask-starter-${starter.id}`}
              onClick={() => onSelect(starter.prompt)}
              className="flex w-full items-start gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-left text-sm text-gray-800 shadow-sm transition hover:border-blue-300 hover:bg-blue-50/40 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <Sparkles className="mt-0.5 h-3.5 w-3.5 shrink-0 text-blue-600" aria-hidden="true" />
              <span>{t(starter.label)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GtmAskStarters;
